import { AxiosResponse } from "axios";
import apiClient from "../http/apiClient";
import { BaseService } from "./BaseService";
import _ from "lodash";
import { VisaApplication } from "../models/VisaApplication";

export class ApplicationService extends BaseService {
    constructor(props?: any) {
        super(props);
    }

    async fetchAll(): Promise<VisaApplication[]> {
        try {
            let response: AxiosResponse = await apiClient.get(`${process.env.REACT_APP_BASE_URL}/application`);
            if (response.status === 200 && _.isArray(response.data)) {
                return Promise.resolve(response.data.map((x: any) => new VisaApplication(x)));
            }
        } catch (e) {
            return Promise.reject('failed request');
        }
        return Promise.reject('failed request');
    }

    async updateApplicationStatus(id: string, status: string, note: string): Promise<any> {
        try {
            const response: AxiosResponse = await apiClient.post(
                `${process.env.REACT_APP_BASE_URL}/application/update-status/${id}`,
                {
                    status,
                    note
                }
            );
            if (response.status === 201) {
                return Promise.resolve(response.data);
            }
        } catch (e) {
            return Promise.reject('Failed to update application status');
        }
        return Promise.reject('Failed to update application status');
    }


}
